module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE FIRST THREE CHAPTERS")]), _vm._v(" of this book correspond to a three-day seminar on Aristotle’s "), _c('i', [_vm._v("Rhetoric")]), _vm._v(" that I conducted in 2008 at the University of Chile in Santiago. These lectures were published in 2010 in book form in a Spanish translation under the title "), _c('i', [_vm._v("Un arte muy frágil: Sobre la retórica de Aristóteles")]), _vm._v(" by Metales Pesados Libros (Santiago, Chile). I thank Rogelio Gonzalez for his translation and, above all, Pablo Oyarzun for the generous "), _c('i', [_vm._v("Prologue")]), _vm._v(" with which he prefaced the book. The original English version of ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" has been published under the title Λόγος, Τόπος, Στοιχεῖον in "), _c('i', [_vm._v("Internationales Jahrbuch für Hermeneutik")]), _vm._v(", ed. G. Figal, Tübingen; Mohr Siebeck, 2009, pp. 147–169. "), _c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" in the section on Heidegger’s conception of theory and reflection is the Andrew Schuwer Lecture that I gave in 2009 on the occasion of the Annual Conference of the Society for Phenomenology and Existential Philosophy in Arlington, Virginia. It has been published under the title “The Duplicity of the Theoretical: On Heidegger’s First Freiburg Lectures” in "), _c('i', [_vm._v("Research in Phenomenology")]), _vm._v(", 40, 1, 2010, pp. 3–19. I thank Koninklijke Brill NV for the permission to republish this essay. "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" is based on the paper I presented at an international conference on “TheorieTheorie” at the Interuniversity Center in Dubrownik, Croatia, in 2009. A first version of it was published in German under the title “Nur Hinsehen oder hütendes Schauen? Zu Heideggers ‘lebensweltlicher’ Begründung der Theorie” in "), _c('i', [_vm._v("TheorieTheorie: Wider die Theoriemüdigkeit in den Geisteswissenschaften")]), _vm._v(", eds. M. Grizelj and O. Jahraus, Munich: Wilhelm Fink, 2011, pp. 417–431. Two three-day seminars on Heidegger’s conception of theory, one at the Centro de Filosofia das Ciências at the University of Lisbon in 2009, the other at the University of Chile, Santiago, made it possible to finalize the texts that now make up the second section. Some of the chapters from "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("the last section of the book, devoted to the question of judgment in Hannah Arendt, have been delivered as talks on several occasions. Versions of what has now become ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" have been presented as talks at the Graduate Center (CUNY), at the Goethe Universität in Frankfurt/Main, Germany, at Roanoke College (on the occasion of the annual meeting of The North American Society for Philosophical Hermeneutics in 2014), and at the University of Tokyo, Japan (also in 2014). Part of "), _c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" was the subject of a talk at the Cardozo Law School, New York, on the occasion of a conference in 2012 on Kant’s "), _c('i', [_vm._v("Critique of Judgment")]), _vm._v(". It has been published under the title “Is a Determinant Judgment Really a Judgment?” in "), _c('i', [_vm._v("Washington University Jurisprudence Review")]), _vm._v(", 6, 1, 2013, pp. 99–120.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f2e200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgement.vue
// module id = 75
// module chunks = 0